import React from 'react';
import {
  Dialog as DialogComponent,
  DialogTitle as DialogTitleComponent,
  DialogPanel as DialogPanelComponent,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

const Dialog = ({ isOpen = false, onClose = null, title, size = 'lg', children }) => {
  return (
    <DialogComponent
      open={isOpen}
      onClose={onClose ? onClose : () => null}
      className="fixed z-50 inset-0 overflow-y-auto"
      unmount={true}
    >
      <div className="fixed inset-0 bg-black/80" aria-hidden="true" />

      <div className="flex items-center justify-center min-h-screen p-6 h-full">
        <div
          className={clsx(
            'relative bg-white rounded-2xl w-full justify-center mx-auto py-6 px-6 flex flex-col max-h-full overflow-auto',
            {
              'max-w-lg': size === 'lg',
              'max-w-xl': size === 'xl',
              'max-w-2xl': size === '2xl',
              'max-w-3xl': size === '3xl',
            },
          )}
        >
          <DialogPanelComponent className="h-full flex-1 flex flex-col overflow-auto px-1">
            {title && (
              <DialogTitleComponent className="text-2xl mb-4">{title}</DialogTitleComponent>
            )}

            {children}
          </DialogPanelComponent>

          {onClose && (
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-900 hover:text-chocolate-600 transition-colors focus:outline-none"
            >
              <XMarkIcon width="24px" height="24px" className="fill-current" />
            </button>
          )}
        </div>
      </div>
    </DialogComponent>
  );
};

export default Dialog;
